import React, { useState } from 'react';
import './RecentPress.scss';
import Card from '../UI/Card/Card';
import { getModuleBackgroundColor } from '../../util/getModuleBackgroundColor';

/**
 * Renders the recent press component
 * @param {string} eyebrowText - label for the section
 * @param {array} cards - collection of card blocks
 * @returns {JSX.Element}
 * @constructor
 */
const RecentPress = ({ eyebrowText, cards }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(6);
  const total = cards.length;

  const handleLoadMore = () => {
    setIsLoading(true);
    // At least make them think there is loading happening...
    setTimeout(() => {
      setLoaded(loaded + 3);
      setIsLoading(false);
    }, 250);
  };

  const renderPaginatedCards = () => {
    return cards
      .slice(0, loaded)
      .map((item, i) => (
        <Card
          key={`card-${i}`}
          date={item?.date}
          type={item?.type}
          logo={item?.logo}
          title={item?.title}
          excerpt={item?.excerpt}
          link={item?.link}
        />
      ));
  };

  return (
    <div className={`c-recent-press ${getModuleBackgroundColor('gray')}`}>
      <div className="c-recent-press__inner">
        <div className="c-recent-press__eyebrow eyebrow-1">
          <span>{eyebrowText}</span>
        </div>
        <div className="c-recent-press__cards-container">{renderPaginatedCards(cards)}</div>
        <div
          className={`c-recent-press__load-more color-black text-cta cta ${
            loaded >= total ? 'remove' : ''
          }`}
        >
          <button aria-label="Load more" className="color-black" onClick={handleLoadMore}>
            <span>{!isLoading ? 'Load More +' : 'Loading ...'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentPress;
